export const getOrderCharacter = (charCodeIndex: number) => {
  return String.fromCharCode(charCodeIndex);
};
